import { H6 } from "@sellar-io/components";

import type { OrderPaymentStatusProps } from "./OrderPaymentStatusLegacy.shared";

type SellarCreditPaymentStatusTextProps = {
  orderStage: OrderPaymentStatusProps["orderStage"];
};

export const SellarCreditPaymentStatusText = ({
  orderStage,
}: SellarCreditPaymentStatusTextProps) => {
  switch (orderStage) {
    case "Accepted":
    case "Requested":
    case "Confirmed":
    case "Dispatched":
    case "Delivered":
      return <H6>Invoice issued on dispatch of order.</H6>;
    case "Cancelled":
      return <H6>Order cancelled</H6>;
    default:
      return null;
  }
};
